import Image from "next/image";

import styled from "styled-components";

import { getOpacityColor, grayScale, pink } from "@enkor/design/colors";
import { APP_SIZE } from "@styles/variables";

export const ImageSliderWrapper = styled.div`
  position: relative;
  overflow: hidden;

  width: 100%;
  height: auto;
  aspect-ratio: 1/1;

  z-index: 1;
`;

export const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;

  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;
  height: auto;
  aspect-ratio: 1/1;
`;

export const DetailImage = styled(Image)`
  object-fit: cover;

  width: 100%;
  height: 100%;
`;

export const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.4) 0.67%,
    rgba(0, 0, 0, 0) 21.24%
  );

  pointer-events: none;
`;

export const CustomSlickDots = styled.div`
  bottom: 10px;
`;

export const DotsList = styled.ul`
  margin: 0;
  margin-bottom: -4px;

  li {
    width: 18px;
    margin: 0;

    button {
      padding: 0;

      transition: all 0.3s ease-in;

      &::before {
        left: 50%;

        color: ${getOpacityColor(grayScale.white, 0.4)};
        font-size: 10px;
        text-align: center;

        opacity: 1;

        transform: translateX(-50%);
      }
    }
  }

  li.slick-active button:before {
    color: ${pink.main};

    opacity: 1;
  }

  li button:hover::before {
    color: ${pink.main};

    opacity: 0.75;
  }
`;
